import React from "react";
import { MultiselectSearchDropdown, NamedProperty, mapToDropdownOption } from "sprint-common-web";

interface ReadOnlyMultiselectSearchDropdownProps {
    values: NamedProperty[];
    placeholder: string;
}

export const ReadOnlyMultiselectSearchDropdown: React.FC<ReadOnlyMultiselectSearchDropdownProps> = (
    props: ReadOnlyMultiselectSearchDropdownProps
) => {
    const { values, placeholder } = props;

    const mockFunctionOnChange = () => {
        return;
    };

    return (
        <MultiselectSearchDropdown
            placeholder={placeholder}
            options={values.map((value) => mapToDropdownOption(value))}
            selectedKeys={values.map((value) => value.id)}
            onChange={mockFunctionOnChange}
            disabled={true}
            tooltip={!values.length ? `No ${placeholder} for current combination of filters` : undefined}
        />
    );
};
